import React from "react";
import { useState, useEffect } from "react";
import { useLocation,useNavigate,useSearchParams,useParams } from 'react-router-dom';
import { Helmet } from "react-helmet";
import Loading from './Loading';
import ManageScoutingReportsEdit from "./ManageScoutingReportsEdit";
import { configData } from "../config";

const ManageScoutingReportsView = () => {

    const [isLoading, setIsLoading] = useState(true);
    const [detailedview, setDetailedView] = useState({});
    const {rid} = useParams();
    const app_url = configData.APP_URL;
    const location  = useLocation();
    //   const successMessage = location.state?.message;
    const[successMessage,setSuccess] = useState('');
    const Message = location.state?.message;
    useEffect(() => {
    if (Message) {
        setSuccess(Message);
        window.history.replaceState({}, '');
    }
    }, [Message, location.state]);

    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'xls':
            case 'xlsx':
            return '/basic/web/images/x-office-spreadsheet.png';
            case 'csv':
            return '/basic/web/images/text-x-generic.png';
            case 'mp4':
            return '/basic/web/images/video-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png';
        }
    };

    const getFullFileUrl = (path) => {
    if (!path) return "";

    if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
    }

    // Update with actual file server path
    const baseUrl = window.location.origin;
    return `${baseUrl}/${path}`;
    };

    useEffect(() => {
        Promise.all([
            retrieveEditScoutReport()
        ]).then(() => {
            setIsLoading(false);
        })
        
        
    },[]);

         async function  retrieveEditScoutReport() {
        const response = await fetch(
        app_url+'smwwscout/retrievescoutreport?id='+rid,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg == "Success") {
          
             setDetailedView(
                {
                   field_scout_report_sport: responsedata.data.result.field_scout_report_sport,
                   field_file_upload: responsedata.data.result.field_scout_report_file_details,
                   field_scout_report_image:responsedata.data.result.field_scout_report_image_details
                }
            );
           

        }
    }
    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (    
                <div className="view-scouting-reports-container">
                       {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                    {detailedview.field_file_upload && (
                        <>
                            <div style={{marginTop: "5px"}}><strong>File to Upload:</strong></div>
                            <img
                                className="file-icon"
                                alt="File icon"
                                src={getFileIcon(detailedview.field_file_upload.name)}
                            />
                            <a
                                href={detailedview.field_file_upload.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="file-link"
                            >
                                {detailedview.field_file_upload.name}
                            </a>
                        </>
                    )}
                      {detailedview.field_scout_report_image?.url && (
                        <>
                            <div style={{marginTop: "1em"}}><strong>Image to Upload:</strong></div>
                            <img
                            className="uploaded-image"
                            alt="Scout Report"
                            src={detailedview.field_scout_report_image.url}
                            style={{ Width: '100px', height: '100px' }}
                        />
                        </>
                    )} 
                    {detailedview.field_scout_report_sport && (
                        <><div style={{marginTop:"1em"}}><strong>Sport:</strong></div> {detailedview.field_scout_report_sport}</>
                    )}
                </div>
            )}
        </>
    );
};
export default ManageScoutingReportsView;